export default __webpack_public_path__ + "static/media/ovary_network.40c4502e.png";